export const COMPANY_LINKS = [
    {
        identifier: "basket",
        url: "/home",
        label: "Home",
    },
    {
        identifier: "about",
        url: "/about-us",
        label: "About Us",
    },
    {
        identifier: "contact",
        url: "/contact-us",
        label: "Contact",
    },
];
